export default __webpack_public_path__ + "static/media/bluemix.131f8105.svg";